import { useContext, useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "moment-timezone";
import { equals } from "../../utils/object.js";
import "react-intl";
import { BreadcrumbsContext } from "./types.js";
function useBreadcrumbsState() {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  function handleBredcrumbsUpdate(newBreadcrumbs) {
    if (breadcrumbs.length !== newBreadcrumbs.length || breadcrumbs.some((b, i) => !equals(b, newBreadcrumbs[i]))) {
      setBreadcrumbs(newBreadcrumbs);
    }
  }
  function handleRenameLastBreadcrumb(title) {
    if (breadcrumbs.length > 0) {
      setBreadcrumbs(breadcrumbs.map((b, i) => i === breadcrumbs.length - 1 ? { ...b, title } : b));
    }
  }
  return {
    breadcrumbs,
    saveBreadcrumbs: handleBredcrumbsUpdate,
    renameLastBreadcrumb: handleRenameLastBreadcrumb
  };
}
function useInitBreadcrumbs(breadcrumbs) {
  const { saveBreadcrumbs } = useContext(BreadcrumbsContext);
  const hasInitialized = useRef(false);
  useEffect(() => {
    if (!hasInitialized.current) {
      saveBreadcrumbs(breadcrumbs);
      hasInitialized.current = true;
    }
  }, []);
}
function useBreadcrumbs() {
  const { breadcrumbs, renameLastBreadcrumb } = useContext(BreadcrumbsContext);
  const navigate = useNavigate();
  return {
    breadcrumbs,
    renameLastBreadcrumb,
    push: navigate,
    goBack: () => navigate(-1)
  };
}
export {
  useBreadcrumbs,
  useBreadcrumbsState,
  useInitBreadcrumbs
};
//# sourceMappingURL=hooks.js.map
